import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { removeUnderscores } from 'utilities/global';
import { getPmtTranslation } from 'translations/translation-utilities';

export const defaultProcessItemFunc = item =>
  getPmtTranslation({
    key: `${item.value}_name`,
    fallback: item.label
  });

export const defaultReturnItemFunc = (item, label) => ({
  label,
  value: item.value,
  image: item.image
});

export const normalizeMethodTypes = (methodTypesList = []) => {
  return methodTypesList.map(({ type, name, image }) => ({
    value: type,
    label: removeUnderscores(name),
    image
  }));
};

export const translateItems = ({
  items,
  overrideProcessItemFunc,
  overrideReturnItemFunc
}) => {
  return items.map(item =>
    translateItem({ item, overrideReturnItemFunc, overrideProcessItemFunc })
  );
};

export const translateItem = ({
  item,
  overrideProcessItemFunc,
  overrideReturnItemFunc
}) => {
  const processItemFunc = overrideProcessItemFunc || defaultProcessItemFunc;
  const translatedLabel = processItemFunc(item);
  const returnItemFunc = overrideReturnItemFunc || defaultReturnItemFunc;
  return returnItemFunc(item, translatedLabel);
};

export const usePmtTranslation = ({
  data,
  overrideProcessItemFunc,
  overrideReturnItemFunc,
  shouldNormalize = true
}) => {
  const [translatedDataResult, setTranslatedData] = useState([]);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (!data || !Array.isArray(data)) return;

    const normalizedData = shouldNormalize ? normalizeMethodTypes(data) : data;
    const translatedData = translateItems({
      items: normalizedData,
      overrideReturnItemFunc,
      overrideProcessItemFunc
    });

    setTranslatedData(translatedData);
  }, [JSON.stringify(data), i18n.language]);

  return translatedDataResult;
};
